import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

export const enum ncaoc_gateway_source {
    Internal = 'internal',
    External = 'external'
}

@Injectable()
export class InternalExternalInterceptor implements HttpInterceptor {
    static isExternal(): boolean {
        const internalExernalFlag = window.sessionStorage.getItem('ciprs_internal_external');
        return internalExernalFlag === ncaoc_gateway_source.External; // assume it's internal if not present
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).map(event => {
            if (event instanceof HttpResponse) {
                // default to Internal if header is missing
                const internalExternalFlag = event.headers.get('ncaoc-gateway-source') || ncaoc_gateway_source.Internal;
                window.sessionStorage.setItem('ciprs_internal_external', internalExternalFlag);
            }
            return event;
        });
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/internal-external-interceptor.ts